import React from 'react';
import { Box } from '@mui/material';
import BeyondGallery from './BeyondGallery';

const BeyondGalleryPage: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        pt: 10,
        background: '#000',
      }}
    >
      <BeyondGallery />
    </Box>
  );
};

export default BeyondGalleryPage;
